import { toast } from "react-toastify";
import axiosInstance from "../../../../axiosInstance";
import { HRMS_FINANCE_API_URL } from "../../../Constants/baseConstant";
import { getDomain, getUserData, getUserId } from "../../Base/helper/baseFunctions";
import NProgress from 'nprogress';


export const GetSalaryStructureHelper = async () => {
    const data = getUserData();
    return await axiosInstance(`/finance/ancillary/getSalaryStructure`, {
        method: "POST",
        baseURL: HRMS_FINANCE_API_URL,
        data: {
            domain_name: data?.domain,
        }
    })
        .then((res) => {
            return { message: "Salary structure retrived successfully", hasError: false, data: res?.data }
        }).catch(err => {
            return { message: "Unable to retrived salary structure", hasError: false, data: err?.response?.data }
        })
}

export const AddSalaryStructureHelper = async (params) => {
    const data = getUserData();
    toast.dismiss()
    return await axiosInstance(`/finance/ancillary/addSalaryStructure`, {
        method: "POST",
        baseURL: HRMS_FINANCE_API_URL,
        data: {
            domain_name: data?.domain,
            user_empid: data?.employee_id,
            name: params?.name,
            code: params?.code,
            is_public: "F"
        }
    })
        .then((res) => {
            return { message: "Salary Structure Added Successfully", hasError: false, data: res?.data }
        }).catch(err => {
            toast.dismiss()
            toast.error(err?.response?.data?.error?.[0]?.message)
            return { message: "Unable to add Salary Structure", hasError: false, data: err?.response?.data }
        })
}

export const UpdateSalaryStructureHelper = async (params) => {
    const data = getUserData();
    toast.dismiss()
    toast.info("Saving...")
    return await axiosInstance(`/finance/ancillary/updateSalaryStructure`, {
        method: "PUT",
        baseURL: HRMS_FINANCE_API_URL,
        data: {
            domain_name: data?.domain,
            user_empid: data?.employee_id,
            sal_structure_id: params?.sal_structure_id,
            name: params?.name,
            code: params?.code,
            is_public: "F"
        }
    })
        .then((res) => {
            toast.dismiss()
            toast.success("Salary Structure Updated Successfully")
            return { message: "Salary Structure Updated Successfully", hasError: false, data: res?.data }
        }).catch(err => {
            toast.dismiss()
            toast.error(err?.response?.data?.error?.[0]?.message)
            return { message: "Unable to update Salary Structure", hasError: false, data: err?.response?.data }
        })
}

export const DeleteSalaryStructureHelper = async (params) => {
    const data = getUserData();
    toast.dismiss()
    toast.info("Deleting...")
    return await axiosInstance(`/finance/ancillary/deleteSalaryStructure`, {
        method: "DELETE",
        baseURL: HRMS_FINANCE_API_URL,
        data: {
            domain_name: data?.domain,
            sal_structure_id: params?.id
        }
    })
        .then((res) => {
            toast.dismiss()
            toast.success("Salary Structure Deleted Successfully")
            return { message: "Salary Structure Deleted Successfully", hasError: false, data: res?.data }
        }).catch(err => {
            toast.dismiss()
            toast.error(err?.response?.data?.error?.[0]?.message)
            return { message: "Unable to Delete Salary Structure", hasError: false, data: err?.response?.data }
        })
}


export const GetSalaryComponentHelper = async (params) => {
    const data = getUserData();
    return await axiosInstance(`/finance/ancillary/getSalaryComponent`, {
        method: "POST",
        baseURL: HRMS_FINANCE_API_URL,
        data: {
            domain_name: data?.domain,
            sal_structure_id: params?.sal_structure_id
        }
    })
        .then((res) => {
            return { message: "Salary structure retrived successfully", hasError: false, data: res?.data }
        }).catch(err => {
            return { message: "Unable to retrived salary structure", hasError: false, data: err?.response?.data }
        })
}

export const AddSalaryComponentHelper = async (params) => {
    const data = getUserData();
    toast.dismiss()
    toast.info("Saving...")
    return await axiosInstance(`/finance/ancillary/addSalaryComponent`, {
        method: "POST",
        baseURL: HRMS_FINANCE_API_URL,
        data: {
            domain_name: data?.domain,
            user_empid: data?.employee_id,
            sal_structure_id: params?.sal_structure_id,
            name: params?.name,
            code: params?.code,
            sal_comp_type_id: params?.sal_comp_type?.sal_comp_type_id,
            ed_flag: params?.ed_flag?.id,
            cal_type: params?.cal_type?.id,
            cal_value: params?.cal_value,
            is_public: "F",
            comp_alias: params?.comp_alias || null,
        }
    })
        .then((res) => {
            toast.dismiss()
            toast.success("Salary Component Added Successfully")
            return { message: "Salary Component Added Successfully", hasError: false, data: res?.data }
        }).catch(err => {
            toast.dismiss()
            toast.error(err?.response?.data?.error?.[0]?.message)
            return { message: "Unable to add Salary Component", hasError: false, data: err?.response?.data }
        })
}

export const UpdateSalaryComponentHelper = async (params) => {
    const data = getUserData();
    toast.dismiss()
    toast.info("Saving...")
    return await axiosInstance(`/finance/ancillary/updateSalaryComponent`, {
        method: "PUT",
        baseURL: HRMS_FINANCE_API_URL,
        data: {
            domain_name: data?.domain,
            user_empid: data?.employee_id,
            sal_structure_id: params?.sal_structure_id,
            salcomponent_id: params?.salary_component_id,
            name: params?.name,
            code: params?.code,
            sal_comp_type_id: typeof (params?.sal_comp_type) === "object" ? params?.sal_comp_type?.sal_comp_type_id : params?.sal_comp_type_id,
            ed_flag: typeof (params?.ed_flag) === "object" ? params?.ed_flag?.id : params?.ed_flag,
            cal_type: typeof (params?.cal_type) === "object" ? params?.cal_type?.id : params?.cal_type,
            cal_value: params?.cal_value,
            is_public: params?.is_public,
            comp_alias: params?.comp_alias,
        }
    })
        .then((res) => {
            toast.dismiss()
            toast.success("Salary Component Updated Successfully")
            return { message: "Salary Component Updated Successfully", hasError: false, data: res?.data }
        }).catch(err => {
            toast.dismiss()
            toast.error(err?.response?.data?.error?.[0]?.message)
            return { message: "Unable to update Salary Component", hasError: false, data: err?.response?.data }
        })
}

export const DeleteSalaryComponentHelper = async (params) => {
    const data = getUserData();
    toast.dismiss()
    toast.info("Deleting...")
    return await axiosInstance(`/finance/ancillary/deleteSalaryComponent`, {
        method: "DELETE",
        baseURL: HRMS_FINANCE_API_URL,
        data: {
            domain_name: data?.domain,
            sal_structure_id: params?.sal_structure_id,
            salcomponent_id: params?.salary_component_id,
        }
    })
        .then((res) => {
            toast.dismiss()
            toast.success("Salary Component Deleted Successfully")
            return { message: "Salary Component Deleted Successfully", hasError: false, data: res?.data }
        }).catch(err => {
            toast.dismiss()
            toast.error(err?.response?.data?.error?.[0]?.message)
            return { message: "Unable to delete Salary Component", hasError: false, data: err?.response?.data }
        })
}


export const GetSalaryComponentTypeHelper = async (params) => {
    const data = getUserData();
    return await axiosInstance(`/finance/ancillary/getSalaryComponentTypes`, {
        method: "POST",
        baseURL: HRMS_FINANCE_API_URL,
        data: {
            domain_name: data?.domain,
        }
    })
        .then((res) => {
            return { message: "Salary Component Types retrived successfully", hasError: false, data: res?.data }
        }).catch(err => {
            return { message: "Unable to retrived Salary Component Types", hasError: false, data: err?.response?.data }
        })
}

export const GetPayDateHelper = async (params) => {
    const data = getUserData();
    return await axiosInstance(`/finance/ancillary/getPayDate`, {
        method: "POST",
        baseURL: HRMS_FINANCE_API_URL,
        data: {
            domain_name: data?.domain,
        }
    })
        .then((res) => {
            return { message: "success", hasError: false, data: res?.data }
        }).catch(err => {
            return { message: "Unable to retrived", hasError: false, data: err?.response?.data }
        })
}

export const UpdatePayDateHelper = async (params) => {
    const data = getUserData();
    toast.dismiss()
    toast.info("Saving...")
    return await axiosInstance(`/finance/ancillary/updatePayDate`, {
        method: "PUT",
        baseURL: HRMS_FINANCE_API_URL,
        data: {
            domain_name: data?.domain,
            pay_day: +params?.pay_day,
        }
    })
        .then((res) => {
            toast.dismiss()
            toast.success("PayDate Updated Successfully")
            return { message: "PayDate Updated Successfully", hasError: false, data: res?.data }
        }).catch(err => {
            toast.dismiss()
            toast.error(err?.response?.data?.error?.[0]?.message)
            return { message: "Unable to update PayDate", hasError: false, data: err?.response?.data }
        })
}
// payroll approver
export const GetPayrollApproverHelper = async (params) => {
    return await axiosInstance(`/finance/ancillary/getPayrollApprover`, {
        method: "POST",
        baseURL: HRMS_FINANCE_API_URL,
        data: {
            domain_name: getDomain(),
            user_id: getUserId(),
        }
    })
        .then((res) => {
            return { message: "success", hasError: false, data: res?.data }
        }).catch(err => {
            return { message: "Unable to retrived", hasError: true, data: err?.response?.data }
        })
}

export const UpdatePayrollApproverHelper = async (params) => {
    toast.dismiss()
    toast.info("Saving...")
    return await axiosInstance(`/finance/ancillary/updatePayrollApprover`, {
        method: "PUT",
        baseURL: HRMS_FINANCE_API_URL,
        data: {
            domain_name: getDomain(),
            user_id: getUserId(),
            approver_employee_fk: params?.approver_employee_fk,
            payroll_approver_id: params?.payroll_approver_id
        }
    })
        .then((res) => {
            toast.dismiss()
            toast.success("Payroll approver updated successfully")
            return { message: "Payroll approver updated successfully", hasError: false, data: res?.data }
        }).catch(err => {
            toast.dismiss()
            toast.error(err?.response?.data?.error?.[0]?.message)
            return { message: "Unable to update payroll approver", hasError: true, data: err?.response?.data }
        })
}



export const GetOverTimeHelper = async (params) => {
    const data = getUserData();
    return await axiosInstance(`/finance/ancillary/getOverTime`, {
        method: "POST",
        baseURL: HRMS_FINANCE_API_URL,
        data: {
            domain_name: data?.domain,
        }
    })
        .then((res) => {
            return { message: "successfully", hasError: false, data: res?.data }
        }).catch(err => {
            return { message: "Unable to retrived", hasError: false, data: err?.response?.data }
        })
}

export const AddOverTimeHelper = async (params) => {
    const data = getUserData();
    toast.dismiss()
    toast.info("Saving...")
    return await axiosInstance(`/finance/ancillary/addOverTime`, {
        method: "POST",
        baseURL: HRMS_FINANCE_API_URL,
        data: {
            domain_name: data?.domain,
            overtime_type: params?.overtime_type,
            overtime_policy: params?.overtime_policy,
            daily_min_eligible_hours: params?.daily_min_eligible_hours || 0,
            weekly_min_eligible_hours: null,
            flat_amount: +params?.flat_amount || null,
            variable_earning_components: params?.variable_earning_components || null,
            variable_overtime_rate: +params?.variable_overtime_rate || null,
            user_id: getUserId(),
            alias_name: params?.alias_name,
            on_netpay: params?.on_netpay ? params?.on_netpay : false,
            on_grosspay: params?.on_grosspay ? params?.on_grosspay : false,
            on_custom: params?.on_custom ? params?.on_custom : false
        }
    })
        .then((res) => {
            toast.dismiss()
            toast.success("Overtime Added Successfully")
            return { message: "Overtime Added Successfully", hasError: false, data: res?.data }
        }).catch(err => {
            toast.dismiss()
            toast.error(err?.response?.data?.error?.[0]?.message)
            return { message: "Unable to add overtime", hasError: false, data: err?.response?.data }
        })
}

export const UpdateOverTimeHelper = async (params) => {
    const data = getUserData();
    toast.dismiss()
    toast.info("Saving...")
    return await axiosInstance(`/finance/ancillary/updateOverTime`, {
        method: "PUT",
        baseURL: HRMS_FINANCE_API_URL,
        data: {
            domain_name: data?.domain,
            overtime_configuration_id: params?.overtime_configuration_id,
            overtime_type: params?.overtime_type,
            overtime_policy: params?.overtime_policy,
            daily_min_eligible_hours: params?.daily_min_eligible_hours || 0,
            weekly_min_eligible_hours:null,
            flat_amount: +params?.flat_amount || null,
            variable_earning_components: params?.variable_earning_components || null,
            variable_overtime_rate: +params?.variable_overtime_rate || null,
            user_id: getUserId(),
            on_netpay: params?.on_netpay ? params?.on_netpay : false,
            on_grosspay: params?.on_grosspay ? params?.on_grosspay : false,
            on_custom: params?.on_custom ? params?.on_custom : false
            // alias_name: params?.alias_name
        }
    })
        .then((res) => {
            toast.dismiss()
            toast.success("Overtime Updated Successfully")
            return { message: "Overtime Updated Successfully", hasError: false, data: res?.data }
        }).catch(err => {
            toast.dismiss()
            toast.error(err?.response?.data?.error?.[0]?.message)
            return { message: "Unable to update overtime", hasError: false, data: err?.response?.data }
        })
}

export const DeleteOverTimeHelper = async (params) => {
    const data = getUserData();
    toast.dismiss()
    toast.info("Deleting...")
    return await axiosInstance(`/finance/ancillary/deleteOverTime`, {
        method: "DELETE",
        baseURL: HRMS_FINANCE_API_URL,
        data: {
            domain_name: data?.domain,
            overtime_configuration_id: params?.overtime_configuration_id,
        }
    })
        .then((res) => {
            toast.dismiss()
            toast.success("Overtime Deleted Successfully")
            return { message: "Overtime Deleted Successfully", hasError: false, data: res?.data }
        }).catch(err => {
            toast.dismiss()
            toast.error(err?.response?.data?.error?.[0]?.message)
            return { message: "Unable to delete overtime", hasError: false, data: err?.response?.data }
        })
}
// --- Leave Wage Config Helpers ---
export const GetLeaveWageHelper = async (params) => {
    const data = getUserData();
    return await axiosInstance(`/finance/ancillary/getLeaveWageConfig`, {
        method: "POST",
        baseURL: HRMS_FINANCE_API_URL,
        data: {
            domain_name: data?.domain,
        }
    })
    .then((res) => {
        return { message: "Leave wage retrieved successfully", hasError: false, data: res?.data }
    }).catch(err => {
        return { message: "Unable to retrieve leave wage", hasError: false, data: err?.response?.data }
    });
};

export const AddLeaveWageHelper = async (params) => {
    const data = getUserData();
    toast.dismiss();
    toast.info("Saving...");
    return await axiosInstance(`/finance/ancillary/addLeaveWageConfig`, {
        method: "POST",
        baseURL: HRMS_FINANCE_API_URL,
        data: {
            domain_name: data?.domain,
            user_id: getUserId(),
            calculation_earning_components: params?.calculation_earning_components,
            standard_paid_days: params?.standard_paid_days,
            leave_eligibility_days: params?.leave_eligibility_days,
        }
    })
    .then((res) => {
        toast.dismiss();
        toast.success("Leave wage added successfully");
        return { message: "Leave wage added successfully", hasError: false, data: res?.data }
    }).catch(err => {
        toast.dismiss();
        toast.error(err?.response?.data?.error?.[0]?.message);
        return { message: "Unable to add Leave Wage", hasError: false, data: err?.response?.data }
    });
};

export const UpdateLeaveWageHelper = async (params) => {
    const data = getUserData();
    toast.dismiss();
    toast.info("Saving...");
    return await axiosInstance(`/finance/ancillary/updateLeaveWageConfig`, {
        method: "PUT",
        baseURL: HRMS_FINANCE_API_URL,
        data: {
            domain_name: data?.domain,
            calculation_earning_components: params?.calculation_earning_components,
            standard_paid_days: params?.standard_paid_days,
            leave_eligibility_days: params?.leave_eligibility_days,
            leave_wages_configuration_id: params?.leave_wages_configuration_id,
            user_id: getUserId(),
        }
    })
    .then((res) => {
        toast.dismiss();
        toast.success("Leave wage updated successfully");
        return { message: "Leave wage updated successfully", hasError: false, data: res?.data }
    }).catch(err => {
        toast.dismiss();
        toast.error(err?.response?.data?.error?.[0]?.message);
        return { message: "Unable to update leave wage", hasError: false, data: err?.response?.data }
    });
};

export const DeleteLeaveWageHelper = async (params) => {
    const data = getUserData();
    toast.dismiss();
    toast.info("Deleting...");
    return await axiosInstance(`/finance/ancillary/deleteLeaveWageConfig`, {
        method: "DELETE",
        baseURL: HRMS_FINANCE_API_URL,
        data: {
            domain_name: data?.domain,
            leave_wages_configuration_id: params?.leave_wages_configuration_id,

        }
    })
    .then((res) => {
        toast.dismiss();
        toast.success("Leave wage deleted successfully");
        return { message: "Leave wage deleted successfully", hasError: false, data: res?.data }
    }).catch(err => {
        toast.dismiss();
        toast.error(err?.response?.data?.error?.[0]?.message);
        return { message: "Unable to delete Leave Wage", hasError: false, data: err?.response?.data }
    });
};
// --- Food Allowance Cofig Helpers ---
export const GetFoodAllowanceHelper = async (params) => {
    const data = getUserData();
    return await axiosInstance(`/finance/ancillary/getFoodAllowanceConfig`, {
        method: "POST",
        baseURL: HRMS_FINANCE_API_URL,
        data: {
            domain_name: data?.domain,
        }
    })
    .then((res) => {
        return { message: "Food allowance retrieved successfully", hasError: false, data: res?.data }
    }).catch(err => {
        return { message: "Unable to retrieve food allowance", hasError: false, data: err?.response?.data }
    });
};

export const UpdateFoodAllowanceHelper = async (params) => {
    const data = getUserData();
    toast.dismiss();
    toast.info("Saving...");
    return await axiosInstance(`/finance/ancillary/updateFoodAllowanceConfig`, {
        method: "PUT",
        baseURL: HRMS_FINANCE_API_URL,
        data: {
            domain_name: data?.domain,
            food_allowance_configuration_pk: params?.food_allowance_configuration_pk,
            food_allowance_type: params?.food_allowance_type,
            flat_amount: params?.flat_amount ? params?.flat_amount : null,
            min_food_allowance_days: params?.min_food_allowance_days ? params?.min_food_allowance_days : null,
            variable_food_allowance_daily_rate: params?.variable_food_allowance_daily_rate ? params?.variable_food_allowance_daily_rate : null,
            variable_food_allowance_max_rate: params?.variable_food_allowance_max_rate ? params?.variable_food_allowance_max_rate : null,
            user_id: getUserId(),
        }
    })
    .then((res) => {
        toast.dismiss();
        toast.success("Food allowance updated successfully");
        return { message: "Food allowance updated successfully", hasError: false, data: res?.data }
    }).catch(err => {
        toast.dismiss();
        toast.error(err?.response?.data?.error?.[0]?.message);
        return { message: "Unable to update food allowance", hasError: false, data: err?.response?.data }
    });
};

// --- Transport Allowance Cofig Helpers ---
export const GetTransportAllowanceHelper = async (params) => {
    const data = getUserData();
    return await axiosInstance(`/finance/ancillary/getTransportAllowanceConfig`, {
        method: "POST",
        baseURL: HRMS_FINANCE_API_URL,
        data: {
            domain_name: data?.domain,
        }
    })
    .then((res) => {
        return { message: "Transport allowance retrieved successfully", hasError: false, data: res?.data }
    }).catch(err => {
        return { message: "Unable to retrieve transport allowance", hasError: false, data: err?.response?.data }
    });
};

export const AddTransportAllowanceHelper = async (params) => {
    const data = getUserData();
    toast.dismiss();
    toast.info("Saving...");
    return await axiosInstance(`/finance/ancillary/addTransportAllowanceConfig`, {
        method: "POST",
        baseURL: HRMS_FINANCE_API_URL,
        data: {
            domain_name: data?.domain,
            transport_allowance_type: params?.transport_allowance_type,
            flat_amount: params?.flat_amount ? params?.flat_amount : null,
            variable_transport_allowance_rate: params?.variable_transport_allowance_rate ? params?.variable_transport_allowance_rate : null,
            user_id: getUserId(),
        }
    })
    .then((res) => {
        toast.dismiss();
        toast.success("Transport allowance added successfully");
        return { message: "Transport allowance added successfully", hasError: false, data: res?.data }
    }).catch(err => {
        toast.dismiss();
        toast.error(err?.response?.data?.error?.[0]?.message);
        return { message: "Unable to add transport allowance", hasError: false, data: err?.response?.data }
    });
};

export const UpdateTransportAllowanceHelper = async (params) => {
    const data = getUserData();
    toast.dismiss();
    toast.info("Saving...");
    return await axiosInstance(`/finance/ancillary/updateTransportAllowanceConfig`, {
        method: "PUT",
        baseURL: HRMS_FINANCE_API_URL,
        data: {
            domain_name: data?.domain,
            transport_allowance_configuration_pk: params?.transport_allowance_configuration_pk,
            transport_allowance_type: params?.transport_allowance_type,
            flat_amount: params?.flat_amount ? params?.flat_amount : null,
            variable_transport_allowance_rate: params?.variable_transport_allowance_rate ? params?.variable_transport_allowance_rate : null,
            user_id: getUserId(),
        }
    })
    .then((res) => {
        toast.dismiss();
        toast.success("Transport allowance updated successfully");
        return { message: "Transport allowance updated successfully", hasError: false, data: res?.data }
    }).catch(err => {
        toast.dismiss();
        toast.error(err?.response?.data?.error?.[0]?.message);
        return { message: "Unable to update transport allowance", hasError: false, data: err?.response?.data }
    });
};

export const DeleteTransportAllowanceHelper = async (params) => {
    const data = getUserData();
    toast.dismiss();
    toast.info("Deleting...");
    return await axiosInstance(`/finance/ancillary/deleteTransportAllowanceConfig`, {
        method: "DELETE",
        baseURL: HRMS_FINANCE_API_URL,
        data: {
            domain_name: data?.domain,
            transport_allowance_configuration_pk: params?.transport_allowance_configuration_pk,
        }
    })
    .then((res) => {
        toast.dismiss();
        toast.success("Transport allowance deleted successfully");
        return { message: "Transport allowance deleted successfully", hasError: false, data: res?.data }
    }).catch(err => {
        toast.dismiss();
        toast.error(err?.response?.data?.error?.[0]?.message);
        return { message: "Unable to delete transport allowance", hasError: false, data: err?.response?.data }
    });
};
// --- PH Allowance Config Helpers ---
export const GetPHAllowanceHelper = async (params) => {
    const data = getUserData();
    return await axiosInstance(`/finance/ancillary/getPHAllowanceConfig`, {
        method: "POST",
        baseURL: HRMS_FINANCE_API_URL,
        data: {
            domain_name: data?.domain,
        }
    })
    .then((res) => {
        return { message: "PH allowance retrieved successfully", hasError: false, data: res?.data }
    }).catch(err => {
        return { message: "Unable to retrieve PH allowance", hasError: false, data: err?.response?.data }
    });
};

export const AddPHAllowanceHelper = async (params) => {
    const data = getUserData();
    toast.dismiss();
    toast.info("Saving...");
    return await axiosInstance(`/finance/ancillary/addPHAllowanceConfig`, {
        method: "POST",
        baseURL: HRMS_FINANCE_API_URL,
        data: {
            domain_name: data?.domain,
            ph_allowance_type: params?.ph_allowance_type,
            flat_amount: params?.flat_amount ? params?.flat_amount : null,
            ph_allowance_earning_components: params?.ph_allowance_earning_components,
            user_id: getUserId(),
        }
    })
    .then((res) => {
        toast.dismiss();
        toast.success("PH allowance added successfully");
        return { message: "PH allowance added successfully", hasError: false, data: res?.data }
    }).catch(err => {
        toast.dismiss();
        toast.error(err?.response?.data?.error?.[0]?.message);
        return { message: "Unable to add PH allowance", hasError: false, data: err?.response?.data }
    });
};

export const UpdatePHAllowanceHelper = async (params) => {
    const data = getUserData();
    toast.dismiss();
    toast.info("Saving...");
    return await axiosInstance(`/finance/ancillary/updatePHAllowanceConfig`, {
        method: "PUT",
        baseURL: HRMS_FINANCE_API_URL,
        data: {
            domain_name: data?.domain,
            ph_allowance_configuration_pk: params?.ph_allowance_configuration_pk,
            ph_allowance_type: params?.ph_allowance_type,
            flat_amount: params?.flat_amount ? params?.flat_amount : null,
            ph_allowance_earning_components: params?.ph_allowance_earning_components,
            ph_rate: params?.ph_rate ? params?.ph_rate : null,
            user_id: getUserId(),
        }
    })
    .then((res) => {
        toast.dismiss();
        toast.success("PH allowance updated successfully");
        return { message: "PH allowance updated successfully", hasError: false, data: res?.data }
    }).catch(err => {
        toast.dismiss();
        toast.error(err?.response?.data?.error?.[0]?.message);
        return { message: "Unable to update PH allowance", hasError: false, data: err?.response?.data }
    });
};

export const GetBonusConfigurationHelper = async (params) => {
    const data = getUserData();
    return await axiosInstance(`/finance/ancillary/getBonusConfiguration`, {
        method: "POST",
        baseURL: HRMS_FINANCE_API_URL,
        data: {
            domain_name: data?.domain,
        }
    })
    .then((res) => {
        return { message: "Bonus configuration retrieved successfully", hasError: false, data: res?.data }
    }).catch(err => {
        return { message: "Unable to retrieve bonus configuration", hasError: false, data: err?.response?.data }
    });
};

export const UpdateBonusConfigurationHelper = async (params) => {
    const data = getUserData();
    toast.dismiss();
    toast.info("Saving...");
    return await axiosInstance(`/finance/ancillary/updateBonusConfiguration`, {
        method: "PUT",
        baseURL: HRMS_FINANCE_API_URL,
        data: {
            domain_name: data?.domain,
            bonus_percentage: params?.bonus_percentage,
            bonus_credit_type_monthly: params?.bonus_credit_type_monthly,
            bonus_credit_if_yearly_month: params?.bonus_credit_if_yearly_month, // 1-12
            user_id: getUserId(),
        }
    })
    .then((res) => {
        toast.dismiss();
        toast.success("Bonus configuration updated successfully");
        return { message: "Bonus configuration updated successfully", hasError: false, data: res?.data }
    }).catch(err => {
        toast.dismiss();
        toast.error(err?.response?.data?.error?.[0]?.message);
        return { message: "Unable to update bonus configuration", hasError: false, data: err?.response?.data }
    });
};

export const DeletePHAllowanceHelper = async (params) => {
    const data = getUserData();
    toast.dismiss();
    toast.info("Deleting...");
    return await axiosInstance(`/finance/ancillary/deletePHAllowanceConfig`, {
        method: "DELETE",
        baseURL: HRMS_FINANCE_API_URL,
        data: {
            domain_name: data?.domain,
            ph_allowance_configuration_pk: params?.ph_allowance_configuration_pk,
        }
    })
    .then((res) => {
        toast.dismiss();
        toast.success("PH allowance deleted successfully");
        return { message: "PH allowance deleted successfully", hasError: false, data: res?.data }
    }).catch(err => {
        toast.dismiss();
        toast.error(err?.response?.data?.error?.[0]?.message);
        return { message: "Unable to delete PH allowance", hasError: false, data: err?.response?.data }
    });
};
// --- Adjustment Components Config Helpers ---
 export const GetPostAdjustmentComponentsHelper = async (params) => {
    const data = getUserData();
    return await axiosInstance(`/finance/ancillary/getPostAdjustmentComponents`, {
        method: "POST",
        baseURL: HRMS_FINANCE_API_URL,
        data: {
            domain_name: data?.domain,
        }
    })
    .then((res) => {
        return { message: "Adjustment components retrieved successfully", hasError: false, data: res?.data }
    }).catch(err => {
        return { message: "Unable to retrieve adjustment components", hasError: true, data: err?.response?.data }
    });
};

export const AddPostAdjustmentComponentsHelper = async (params) => {
    const data = getUserData();
    toast.dismiss();
    toast.info("Saving...");
    return await axiosInstance(`/finance/ancillary/addPostAdjustmentComponents`, {
        method: "POST",
        baseURL: HRMS_FINANCE_API_URL,
        data: {
            domain_name: data?.domain,
            user_id: getUserId(),
            post_adjustment_components: params?.post_adjustment_components,
            taxable_flag: params?.taxable_flag ? params?.taxable_flag : false,
            is_esic_applicable: params?.is_esic_applicable ? params?.is_esic_applicable : false,

        }
    })
    .then((res) => {
        toast.dismiss();
        toast.success("Adjustment component added successfully");
        return { message: "Adjustment component added successfully", hasError: false, data: res?.data }
    }).catch(err => {
        toast.dismiss();
        toast.error(err?.response?.data?.error?.[0]?.message);
        return { message: "Unable to add adjustment component", hasError: true, data: err?.response?.data }
    });
};

export const UpdatePostAdjustmentComponentsHelper = async (params) => {
    const data = getUserData();
    toast.dismiss();
    toast.info("Saving...");
    return await axiosInstance(`/finance/ancillary/updatePostAdjustmentComponents`, {
        method: "PUT",
        baseURL: HRMS_FINANCE_API_URL,
        data: {
            domain_name: data?.domain,
            user_id: getUserId(),
            post_adjustment_components: params?.post_adjustment_components,
            post_adjustment_components_id: +params?.post_adjustment_components_id,
            taxable_flag: params?.taxable_flag ? params?.taxable_flag : false,
            is_esic_applicable: params?.is_esic_applicable ? params?.is_esic_applicable : false,
        }
    })
    .then((res) => {
        toast.dismiss();
        toast.success("Adjustment component updated successfully");
        return { message: "Adjustment component updated successfully", hasError: false, data: res?.data }
    }).catch(err => {
        toast.dismiss();
        toast.error(err?.response?.data?.error?.[0]?.message);
        return { message: "Unable to update adjustment component", hasError: true, data: err?.response?.data }
    });
};

export const DeletePostAdjustmentComponentsHelper = async (params) => {
    const data = getUserData();
    toast.dismiss();
    toast.info("Deleting...");
    return await axiosInstance(`/finance/ancillary/deletePostAdjustmentComponents`, {
        method: "DELETE",
        baseURL: HRMS_FINANCE_API_URL,
        data: {
            domain_name: data?.domain,
            post_adjustment_components_id: +params?.post_adjustment_components_id

        }
    })
    .then((res) => {
        toast.dismiss();
        toast.success("Adjustment component deleted successfully");
        return { message: "Adjustment component deleted successfully", hasError: false, data: res?.data }
    }).catch(err => {
        toast.dismiss();
        toast.error(err?.response?.data?.error?.[0]?.message);
        return { message: "Unable to delete adjustment component", hasError: true, data: err?.response?.data }
    });
};

export const AddEsicEpfoShortcutHelper = async (params) => {
    toast.dismiss()
    toast.info("Saving...")
    return await axiosInstance(`/finance/ancillary/addEsicEpfoShoutcut`, {
        method: "POST",
        baseURL: HRMS_FINANCE_API_URL,
        data: {
            domain_name: getDomain(),
            employee_fk: params?.employee_fk,
            pf_no: params?.pf_no,
            esi_no: params?.esi_no,
            uan: params?.uan,
        }
    })
        .then((res) => {
            toast.dismiss()
            toast.success("Updated successfully")
            return { message: "Updated successfully", hasError: false, data: res?.data }
        }).catch(err => {
            toast.dismiss()
            toast.error(err?.response?.data?.error?.[0]?.message)
            return { message: "Unable to update", hasError: true, data: err?.response?.data }
        })
}

// --- ECMS Adjustment Components Config Helpers ---
export const GetECMSComponentsHelper = async () => {
    NProgress.start();
    return await axiosInstance(`/finance/ecms/getECMSComponents`, {
        method: "POST",
        baseURL: HRMS_FINANCE_API_URL,
        data: {
            domain_name: getDomain(),
        }
    })
    .then((res) => {
        NProgress.done();
        return { message: "ECMS adjustment components retrieved successfully", hasError: false, data: res?.data }
    }).catch(err => {
        NProgress.done();
        return { message: "Unable to retrieve ECMS adjustment components", hasError: true, data: err?.response?.data }
    });
};

export const AddECMSComponentsHelper = async (params) => {
    toast.dismiss();
    toast.info("Saving...");
    return await axiosInstance(`/finance/ecms/addECMSComponents`, {
        method: "POST",
        baseURL: HRMS_FINANCE_API_URL,
        data: {
            domain_name: getDomain(),
            user_id: getUserId(),
            ecms_adjustments_configuration_json: params?.ecms_adjustments_configuration_json,
            taxable_flag: params?.taxable_flag ? params?.taxable_flag : false,
        }
    })
    .then((res) => {
        toast.dismiss();
        toast.success("Component added successfully");
        return { message: "Component added successfully", hasError: false, data: res?.data }
    }).catch(err => {
        toast.dismiss();
        toast.error(err?.response?.data?.error?.[0]?.message);
        return { message: "Unable to add component", hasError: true, data: err?.response?.data }
    });
};

export const UpdateECMSComponentsHelper = async (params) => {
    toast.dismiss();
    toast.info("Saving...");
    return await axiosInstance(`/finance/ecms/updateECMSComponents`, {
        method: "PUT",
        baseURL: HRMS_FINANCE_API_URL,
        data: {
            domain_name: getDomain(),
            user_id: getUserId(),
            ecms_adjustments_configuration_json: params?.ecms_adjustments_configuration_json,
            ecms_adjustments_configuration_id: +params?.ecms_adjustments_configuration_id,
            taxable_flag: params?.taxable_flag ? params?.taxable_flag : false,
        }
    })
    .then((res) => {
        toast.dismiss();
        toast.success("Component updated successfully");
        return { message: "Component updated successfully", hasError: false, data: res?.data }
    }).catch(err => {
        toast.dismiss();
        toast.error(err?.response?.data?.error?.[0]?.message);
        return { message: "Unable to update component", hasError: true, data: err?.response?.data }
    });
};

export const DeleteECMSComponentsHelper = async (params) => {
    toast.dismiss();
    toast.info("Deleting...");
    return await axiosInstance(`/finance/ecms/deleteECMSComponents`, {
        method: "DELETE",
        baseURL: HRMS_FINANCE_API_URL,
        data: {
            domain_name: getDomain(),
            ecms_adjustments_configuration_id: +params?.ecms_adjustments_configuration_id,
        }
    })
    .then((res) => {
        toast.dismiss();
        toast.success("Component deleted successfully");
        return { message: "Component deleted successfully", hasError: false, data: res?.data }
    }).catch(err => {
        toast.dismiss();
        toast.error(err?.response?.data?.error?.[0]?.message);
        return { message: "Unable to delete component", hasError: true, data: err?.response?.data }
    });
};
